import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

// Interfaccia per i dati dei comuni
interface Comune {
    codiceIstatComuneAlfa: string;
    nomeIt: string;
    cap: string;
    siglaProvincia: string;
}

// Funzione hook per recuperare i comuni
export const useGetComuni = (siglaProvincia: string) => {
    const [comuni, setComuni] = useState<Comune[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchComuni = async () => {
            if (!siglaProvincia) return; // Blocco call-to-API se manca parametro provincia
            try {
                const response = await axios.post(`${API_BASE_URL}/comuni`, { siglaProvincia });
                setComuni(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Errore API:", error);
                setError("Impossibile recuperare i dati");
                setLoading(false);
            }
        };
        fetchComuni();
    }, [siglaProvincia]);

    return { comuni, loading, error };
}

export default useGetComuni;
